import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

import { route_path } from '@app/utils/route_path';

type Store = {
  showSuccess: boolean;
  showError: boolean;
  showCancel: boolean;
  cancelBackUrl: string;
};

type Actions = {
  closeSuccess: () => void;
  closeError: () => void;
  closeCancel: () => void;
  parsePaymentParams: () => void;
};

const defaultState: Store = {
  showSuccess: false,
  showError: false,
  showCancel: false,
  cancelBackUrl: route_path.pricing,
};

export const usePaymentNotify = create<Store & Actions>()(
  immer((set) => ({
    ...defaultState,
    closeSuccess: () => {
      set((state) => {
        state.showSuccess = false;
      });
    },
    closeError: () => {
      set((state) => {
        state.showError = false;
      });
    },
    closeCancel: () => {
      set((state) => {
        state.showCancel = false;
      });
    },
    // LEGACY: старая реализация парсинга payment query-параметров из URL.
    // Этот код был на проекте с самого начала и работает как есть.
    // Не трогать без крайней необходимости - логика сохранена один-в-один.
    parsePaymentParams: () => {
      const { search, href } = window.location;

      if (search.includes('success')) {
        set((state) => {
          state.showSuccess = true;
        });
        window.history.replaceState({}, document.title, href.replace(/(\?|&)+success/, ''));
      } else if (search.includes('error')) {
        set((state) => {
          state.showError = true;
        });
        window.history.replaceState({}, document.title, href.replace(/(\?|&)+error/, ''));
      } else {
        if (search.includes('cancel')) {
          set((state) => {
            state.showCancel = true;
          });
          window.history.replaceState({}, document.title, href.replace(/(\?|&)+cancel/, ''));
        }

        const gotoProduct = window.sessionStorage.getItem('gotoProduct');
        if (gotoProduct) {
          const parsed = JSON.parse(gotoProduct);
          set((state) => {
            state.showCancel = true;
            state.cancelBackUrl = parsed.url;
          });
        }
      }

      window.sessionStorage.removeItem('gotoProduct');
    },
  })),
);
